<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <ep-factory-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></ep-factory-form>
  </j-modal>
</template>

<script>

  import EpFactoryForm from './EpFactoryForm'
  export default {
    name: 'EpFactoryModal',
    components: {
      EpFactoryForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>